import React from 'react'
import { Backdrop, CircularProgress } from '@mui/material'

const LoadingBackdrop = ({ open, message = "Loading..." }) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: 'absolute',
                borderRadius: 1,
                flexDirection: 'column',
                gap: 2,
            }}
            open={open}
        >
            <CircularProgress color="inherit" />
            {message && (
                <div style={{ fontSize: '16px', fontWeight: 500 }}>
                    {message}
                </div>
            )}
        </Backdrop>
    )
}

export default LoadingBackdrop 